export type ProductCategory =
  | "Bakery"
  | "ServingLines"
  | "CoffeeBar"
  | "Industrial"
  | "Mechanical"
  | "Tableware"
  | "Warewashing"
  | "Chemicals"
  | "Thermal"
  | "Refrigeration"
  | "Laundry"
  | "Neutral";

export const CATEGORY_LABELS: Record<ProductCategory, string> = {
  Bakery: "Пекарское",
  ServingLines: "Линии раздачи",
  CoffeeBar: "Кофейное & Барное",
  Industrial: "Индустриальное",
  Mechanical: "Электромеханическое",
  Tableware: "Посуда и инвентарь",
  Warewashing: "Посудомоечное",
  Chemicals: "Химия",
  Thermal: "Тепловое",
  Refrigeration: "Холодильное",
  Laundry: "Прачечное",
  Neutral: "Нейтральное",
};

export const CATEGORY_SUBCATEGORIES: Record<ProductCategory, string[]> = {
  Thermal: [
    "Пароконвектоматы",
    "Печи для пиццы",
    "Высокоскоростные печи",
    "Конвекционные печи",
    "Микроволновые печи",
    "Грили",
    "Плиты кухонные",
    "Плиты контактной жарки",
    "Варочные котлы",
    "Фритюрницы",
    "Сковороды опрокидываемые",
    "Пароварочные аппараты",
    "Пастоварки",
    "Мармиты",
    "Рисоварки",
    "Аппараты для кур-гриль",
    "Регенерационные шкафы",
    "Аппараты для гироса",
    "Аппараты для хот-догов",
    "Сувид-оборудование",
    "Тепловые ленты",
    "Тепловые лампы",
    "Фрай-станции",
    "Карвинг-станции",
    "Портативные мармиты",
    "Тепловые ящики",
    "Встраиваемые мармиты",
    "Витрины-мармиты",
    "Тепловые шкафы",
    "Тостеры",
    "Индукционное оборудование",
    "Легкое кухонное оборудование",
    "Водонагреватели",
    "Аксессуары",
  ],
  Refrigeration: [
    "Шкафы шоковой заморозки",
    "Столы охлаждаемые",
    "Льдогенераторы",
    "Холодильные шкафы",
    "Диспенсеры льда и воды",
    "Пивные диспенсеры",
    "Витрины для суши",
    "Многопалубные витрины",
    "Льдодробилки",
    "Бункеры для льда",
    "Морозильные лари",
    "Морозильные шкафы",
    "Витрины для мороженого",
    "Пивные холодильники",
    "Винные шкафы",
    "Витрины кондитерские",
    "Витрины вертикальные",
    "Витрины самообслуживания",
    "Витрины для тапас",
    "Витрины нейтральные",
  ],
  Warewashing: ["Фронтальные", "Купольные", "Туннельные машины", "Аксессуары"],
  Chemicals: ["Моющие средства"],
  Bakery: [
    "Конвекционные печи",
    "Подовые печи",
    "Ротационные печи",
    "Расстоечные шкафы",
    "Тестомесы",
    "Тестораскаточные машины",
    "Тестоделители",
    "Тестоокруглители",
    "Витрины тепловые",
    "Охладители воды",
    "Миксеры планетарные",
    "Круассановые линии",
    "Столы для раскатки и резки теста",
    "Дозаторы теста и начинки",
    "Варочные аппараты для кондитерских кремов",
    "Фритюрницы для пончиков",
    "Шоколадное оборудование",
    "Измельчители сахара",
    "Прессы для теста и масла",
    "Хлеборезки",
    "Измельчители для сухарей и специй",
    "Мукопросеиватели",
    "Шкафы шоковой заморозки",
    "Аксессуары",
  ],
  CoffeeBar: [
    "Кофемашины",
    "Блендеры",
    "Соковыжималки",
    "Стимеры для молока",
    "Диспенсеры горячей воды",
    "Автоматы для чайных напитков",
    "Миксеры для молочных коктейлей",
    "Аксессуары для бара",
    "Закаточные машины для банок",
  ],
  Industrial: [
    "Мясорубки",
    "Овощерезки",
    "Пилы ленточные",
    "Слайсеры",
    "Овощемойки",
    "Сушилки для овощей",
    "Овощеочистительные машины",
    "Куттеры",
    "Формовочные машины",
    "Панировочные машины",
    "Аксессуары",
    "Туннельные машины",
    "Компактные моечные машины",
    "Моечные кабины",
    "Дезинфекционные системы",
    "Автоматизация и обработка тары",
    "Оборудование для перемешивания",
    "Оборудование для разморозки",
    "Оборудование для массирования и тумблирования",
    "Оборудование для маринования и инъектирования",
    "Оборудование для обжарки и варки",
    "Оборудование для заморозки",
    "Системы взвешивания и контроля",
    "Системы загрузки",
    "Термоформовочное оборудование",
    "Этикетировочное оборудование",
    "Вертикальная упаковка",
    "Дозирующее оборудование",
  ],
  Mechanical: [
    "Аксессуары для электро-механического оборудования",
    "Аппараты пельменные",
    "Бликсеры",
    "Гомогенизаторы",
    "Измельчители для сухарей и специй",
    "Измельчители отходов",
    "Картофелечистки",
    "Конвейеры",
    "Куттеры",
    "Маринаторы",
    "Массажеры вакуумные",
    "Машины для производства пасты",
    "Машины для формовки котлет и гамбургеров",
    "Машины и приводы универсальные кухонные",
    "Меланжеры",
    "Миксеры планетарные",
    "Миксеры ручные",
    "Мукопросеиватели",
    "Мясорубки",
    "Мясорыхлители",
    "Овощерезательные и протирочные машины",
    "Открывалки для консервов",
    "Пилы для резки мяса",
    "Прессы для гамбургеров",
    "Прессы для пиццы",
    "Процессоры кухонные",
    "Расходные материалы для электромеханического оборудования",
    "Рыбочистки",
    "Слайсеры",
    "Сырорезки и сыротерки",
    "Тестоделители",
    "Тестозакаточные машины",
    "Тестомесы",
    "Тестоокруглители",
    "Тестораскатывающие машины",
    "Устройства механические",
    "Фаршемешалки",
    "Ферментаторы",
    "Хлеборезки",
    "Шприцы колбасные",
    "Вакуумные упаковочные машины",
    "Термоупаковщики для лотков",
    "Упаковочные столы",
    "Стерилизаторы для ножей",
    "Шкуросъёмные машины",
  ],
  Tableware: [
    "Тарелки",
    "Пиалы и чаши",
    "Супницы",
    "Соусники и блюдца",
    "Подносы и лотки",
    "Чашки и сервировочные наборы",
    "Столовые приборы",
    "Стеклянная посуда",
    "Посуда для готовки",
    "Кухонные принадлежности",
    "Подставки и подиумы",
  ],
  Neutral: [
    "Столы производственные",
    "Ванны моечные",
    "Стеллажи",
    "Тележки",
    "Автоматизация и обработка тары",
  ],
  ServingLines: [
    "Прилавки охлаждаемые",
    "Прилавки тепловые",
    "Лампы для линий раздачи",
    "Тележки сервировочные",
    "Модульные линии на заказ",
  ],
  Laundry: ["Стиральные машины", "Сушильные автоматы", "Гладильные катки (каландры)"],
};

export interface Product {
  id: string;
  category: ProductCategory;
  subcategory?: string;
  brand?: string;
  name: string;
  model: string;
  image: string;
  specs: string[];
  characteristics?: Record<string, string | number>;
  price?: number;
  stockQuantity?: number;
  leadTimeDays?: number;
  onSale?: boolean;
  description?: string;
  images?: string[];
  /** Dedicated swatch photo for a color-variant picker option, independent
   * of `image`/`images` (the product's own hero/gallery photos) — lets a
   * card show the real item as its thumbnail while the color picker still
   * shows a genuine per-color chip (see productGroups.ts's color axis). */
  swatchImage?: string;
  videoId?: string;
  brochureUrl?: string;
  applications?: string[];
  containerTypes?: ContainerType[];
  /** Free-text aliases for this specific product (colloquial names, an
   * alternate spelling, an abbreviation) that search should match against
   * as if they were part of the name — distinct from searchSynonyms.ts's
   * global term-to-term dictionary, which maps generic vocabulary rather
   * than tagging one product. */
  searchKeywords?: string[];
}

export type ContainerType = "glass" | "tin" | "bucket" | "tray" | "pouch";

export const CONTAINER_TYPE_LABELS: Record<ContainerType, string> = {
  glass: "Стеклянные банки/бутылки",
  tin: "Жестяные/алюминиевые банки",
  bucket: "Пластиковые вёдра",
  tray: "Лотки",
  pouch: "Пауши/мешки",
};

export interface Sector {
  id: string;
  title: string;
  description: string;
  image: string;
}
